import React, {createContext, Dispatch, ReactNode, SetStateAction, useState} from 'react';

type DropDownMenuContextProps = {
    currentWindow: string,
    setCurrentWindow: Dispatch<SetStateAction<string>>
}

export const DropDownMenuContext = createContext<DropDownMenuContextProps>({
    currentWindow: "main",
    setCurrentWindow: () => {}
})

type DropDownMenuProps = {
    children: ReactNode;
    initWindow: string
}

function DropDownMenu(props: DropDownMenuProps) {
    const [currentWindow, setCurrentWindow] = useState(props.initWindow)
    return (
        <DropDownMenuContext.Provider value={{currentWindow, setCurrentWindow}}>
            <div className="dropdown-menu">
                {props.children}
            </div>
        </DropDownMenuContext.Provider>
    );
}

export default DropDownMenu;
